import { PaymentApi } from '@linktivity/link-payment-admin';
import config from '../config';

const paymentApi = new PaymentApi(config);

export default paymentApi;
